import api from "@/lib/api";

// Internal analytics (MongoDB). Kept as-is; does NOT push to GA4 to avoid
// polluting GA4 with non-standard event names.
export const track = (event, data = {}) => {
  try {
    api.post("/analytics/event", { event, data }).catch(() => {});
  } catch (e) {}
};

// Safe GA4 event helper. Uses the global gtag installed in index.html.
export const gaEvent = (name, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (e) {}
};
